import { render, staticRenderFns } from "./MetricsTable.vue?vue&type=template&id=48da8084&scoped=true&"
import script from "./MetricsTable.vue?vue&type=script&lang=js&"
export * from "./MetricsTable.vue?vue&type=script&lang=js&"
import style0 from "./MetricsTable.vue?vue&type=style&index=0&id=48da8084&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48da8084",
  null
  
)

export default component.exports